const initialState = {
  credit_cstm: '',
  foreclosure: '',
  bankruptcy: '',
  experience: '',
  non_entity_borrower: '',
  us_citizen: '',
  backButton: false,
  experience_lifetime: '',

  //
  checking_1_b: null,
  checking_2_b: null,
  savings_1_b: null,
  savings_2_b: null,
  stocks_bonds_1_b: null,
  stocks_bonds_2_b: null,
  retirement_1_b: null,
  retirement_2_b: null,
  other_real_estate_b: null,

  //
  owed_primary_residence_b: null,
  owed_other_real_estate_b: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_BORROWER_INFO':
      return { ...state, ...action.payload };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducer/borrowerInfo.reducer.js